import { InstanceResponseDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { Observable, filter } from 'rxjs';
import { MasterOperatorConnectItemsSettings } from '../models/master-operator-connect-settings';

// Using a fn to get settings because, if we did not, the settings
// would be set when we set the operator, not when the actual filter is executed.
// This means the operator could have an older version of the settings.
export function instanceBelongsToConnectSettings(
  settingsFn: () => MasterOperatorConnectItemsSettings
) {
  return function <T>(source: Observable<InstanceResponseDto>) {
    return source.pipe(
      filter((instance) => {
        const settings = settingsFn();
        return !!settings.items.find((item) => item.instanceId === instance.instanceId);
      })
    );
  };
}
